var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11 3.383a7.7 7.7 0 1 0 4.928 13.618l3.578 3.577a.7.7 0 0 0 .99-.99l-3.578-3.577a7.7 7.7 0 0 0-5.917-12.627m-6.3 7.7a6.3 6.3 0 1 1 12.6 0 6.3 6.3 0 0 1-12.6 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11 7.283a.7.7 0 0 1 .7.7v2.4h2.4a.7.7 0 1 1 0 1.4h-2.4v2.4a.7.7 0 1 1-1.4 0v-2.4H7.9a.7.7 0 1 1 0-1.4h2.4v-2.4a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
})));
export default SvgSearchPlus;